<template >
  <v-layout class="my-3" align-center>
    <v-flex d-flex xs12>
      <v-chip class="success black--text d-flex" outline label v-if="organization.publishedAt">
        Organization published at
        {{ new Date(organization.publishedAt) | date("h:mm a, MMMM Do yyy") }}
        ({{ new Date(organization.publishedAt) | inWords({ addSuffix: true }) }})
      </v-chip>
      <v-chip class="warning warning--text d-flex" outline label v-if="!organization.publishedAt">
        The Organization is not published, therefore all associated opportunities will not be published
      </v-chip>
    </v-flex>
    <v-dialog v-model="publishing" max-width="400px" v-if="!organization.publishedAt && edit">
      <v-btn small color="secondary darken-2" slot="activator">
        <v-icon left>public</v-icon> Publish
      </v-btn>
      <v-card>
        <v-card-title class="secondary darken-2 title">
          Publish now?
          <v-spacer />
          <v-btn icon flat @click="publishing = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          Are you sure you would like to make the organization publicly visible?
          <div class="text-xs-right">
            <v-btn flat @click="publishing = false">Cancel</v-btn>
            <v-btn color="accent" @click="publish">Publish</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: { organization: Object, edit: Boolean },
  data() {
    return {
      publishing: false
    }
  },
  methods: {
    publish() {
      this.$store
        .dispatch(
          'client/organization/update',
          Object.assign(JSON.parse(JSON.stringify(this.organization)), { publishedAt: this.$date(new Date()) })
        )
        .then(errors => {
          if (errors) {
            this.$store.dispatch('snackbarError', 'The organization was not published')
          } else {
            this.$store.dispatch('snackbarSuccess', 'The organization was published')
          }
        })
      this.publishing = false
    }
  }
}
</script>
